import React, { useState , useEffect } from 'react';

const AboutUs = () => {
  useEffect(() => {
    const cards = document.querySelectorAll('.industry-card');
  
    cards.forEach(card => {
      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
  
        card.style.setProperty('--x', `${x}px`);
        card.style.setProperty('--y', `${y}px`);
        card.style.setProperty('--size', '750px');
      };
  
      const handleMouseLeave = () => {
        card.style.setProperty('--size', '0px');
      };
  
      card.addEventListener('mousemove', handleMouseMove);
      card.addEventListener('mouseleave', handleMouseLeave);
  
      
      card._handleMouseMove = handleMouseMove;
      card._handleMouseLeave = handleMouseLeave;
    });
  
    
    return () => {
      cards.forEach(card => {
        card.removeEventListener('mousemove', card._handleMouseMove);
        card.removeEventListener('mouseleave', card._handleMouseLeave);
      });
    };
  }, []);
  
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);  

  useEffect(() => {
    const changeImage = () => {
      setFade(false); 
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 3);  
        setFade(true);  
      }, 400); 
    };

    const interval = setInterval(changeImage, 3000); 

    return () => clearInterval(interval);
  }, []); 

  const images = ["assets/images/abt2.webp", "assets/images/hero.webp", "assets/images/image 16.webp"];

  return (
    <>
    <main className="container-fluid p-0">
       <section className="aboutus-section">
       <div className="about-us-wrapper">
       <div className="aboutus-content-section">
                    <h1 className="card-title-xl fw-l text-balance">Who Are We ?</h1>
                    <p className="paragraph-md">
                        Understand how we collect, use, and protect your information.
                    </p>
                </div>
        <div className="aboutus-image-section">
          <div className="image-container">
            <img
              src={images[currentImageIndex]}
              alt=""
              role="presentation"
              className={`fade-image ${fade ? 'active' : ''}`} 
              style={{ transition: 'opacity 1s ease-in-out' }} 
              loading='lazy'
            />
          </div>
        </div>
        <div className="aboutus-description-section">
                    <p className="xsmall">
                    At Credence Resource Management, based in
             Dallas, Texas, we are committed to fostering trust, transparency, 
            and fairness in Accounts Receivable Management and Asset Protection. Our mission is to
             support clients across healthcare, telecommunications, and retail industries, 
            while offering consumers respectful, secure, and convenient solutions for resolving their financial obligations. <br />
            Through advanced technology and a hybrid
             engagement approach, we deliver tailored strategies to improve cash
             flow for our clients, ensuring that every consumer interaction is empathetic, professional
             , and respectful. Our secure online payment portal provides a seamless
             , user-friendly experience, prioritizing the safety of your payment information and the confidentiality of your personal data. <br />
            Since 1988, our leadership team has developed
             scalable solutions for first- and third-party recovery, serving 
            industries such as healthcare, financial services, telecommunications, and utilities. Our
             approach emphasizes strict compliance with regulatory standards, sensitivity
             to consumer needs, and safeguarding the reputations of the brands we represent. <br />
            Whether you’re a client seeking innovative recovery
             strategies or a consumer looking for a trusted partner to
             resolve financial obligations, Credence is here to help. We pride ourselves on building
              bridges of understanding while delivering outstanding results for all
              stakeholders.
                    </p>
                </div>
        </div>
      </section>
      
      <section className="industry-section">
            <div className="industry-container">
                <div className="industry-text-wrapper">
                    <div className="industry-text-container">
                        <h1 className="section-title">
                            Industries we Serve
                        </h1>
                        <p className="section-description">
                            "Mastering revenue cycle management, we reclaim and optimize your financial resources with precision
                            and professionalism."
                        </p>
                    </div>
                </div>
                <div className="industry-content-container">
                   
                        <div className="industry-card-grid" aria-label="Industries we serve">
                        <article id="industry-card1 industryimg1" className="industry-card art-ind-one" role="article" aria-labelledby="industry-card1-title" style={{backgroundImage: "assets/public/images/industry (1).webp"}}>
                            <div className="industry-card-content">
                                <h2 id="industry-card1-title" className="industry-card-title">Healthcare</h2>
                                <p className="industry-card-subtitle">Our skilled customer service teams, with deep industry knowledge, leverage
                                    cutting-edge BPO
                                    services and
                                    technology solutions. This enables us to consistently deliver exceptional collections,
                                    recovery, and
                                    revenue generation results for media and entertainment clients, while optimizing system
                                    efficiency and
                                    protecting your brand’s reputation</p>
                            </div>
                        </article>
                        <article id="industry-card industryimg2" className="industry-card art-ind-two" role="article" aria-labelledby="industry-card2-title" style={{ backgroundImage: "assets/public/images/industry (2).webp" }}>
                            <div className="industry-card-content">
                                <h2 id="industry-card2-title" className="industry-card-title">Telecommunication</h2>
                                <p className="industry-card-subtitle">We combine deep domain expertise with cutting-edge BPO services and
                                    technology solutions to
                                    deliver exceptional
                                    financial results for telecommunications providers. By utilizing a consultative approach and
                                    leveraging
                                    industry-specific platforms, we maximize recoveries, increase revenue, and ensure a seamless
                                    customer service
                                    experience that safeguards your reputation.</p>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        
        </section>


<section className="service-section" id="section3">
            <div className="service-container">
                <div className="service-text-wrapper">
                    <div className="service-text-container">
                    <h2 className="section-title">Our Services</h2>
                        <p className="section-description">
                            "Delivering expert solutions to optimize cash flow and protect your business."
                        </p>
                    </div>
                </div>
                <div className="service-card-container">
                    <div className="services-grid">
                        <div className="row g-4 justify-content-center">
                            <div className="col-md-6 col-sm-12">
                                <div className="service-card">
                                    <div className="service-img">
                                        <img src="assets/images/icon-set/icon (4).webp" alt="" className="service-icon" role="presentation" loading='lazy'/>
                                    </div>
                                    <h3 className="ser-header">Third-Party Collections</h3>
                                    <p className="ser-description">Our skilled specialists handle overdue accounts with professionalism, focusing on
                                        maximizing recovery rates. Efforts are tailored to safeguard your brand's reputation while addressing financial
                                        challenges.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                                <div className="service-card">
                                    <div className="service-img">
                                        <img src="assets/images/icon-set/icon (1).webp" alt="" className="service-icon" role="presentation" loading='lazy'/>
                                    </div>
                                    <h3 className="ser-header">Patient Pay Collections</h3>
                                    <p className="ser-description">We offer specialized solutions that simplify patient billing processes and enable timely
                                        collections for healthcare providers. A patient-focused strategy enhances financial performance and customer
                                        satisfaction.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                                <div className="service-card">
                                    <div className="service-img">
                                        <img src="assets/images/icon-set/icon (5).webp" alt="" className="service-icon" role="presentation" loading='lazy'/>
                                    </div>
                                    <h3 className="ser-header">Dispute Resolution</h3>
                                    <p className="ser-description">Disputes are resolved swiftly and effectively to minimize financial risks and maintain
                                        trust. Our service is designed to strengthen relationships while streamlining processes to create a seamless
                                        experience.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                                <div className="service-card">
                                    <div className="service-img">
                                        <img src="assets/images/icon-set/icon (3).webp" alt="" className="service-icon" role="presentation" loading='lazy'/>
                                    </div>
                                    <h3 className="ser-header">Fraud Mitigation</h3>
                                    <p className="ser-description">We leverage intelligent technologies to detect and prevent fraudulent activities,
                                        safeguarding businesses from financial losses. Our proactive measures ensure robust protection and operational
                                        security.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>  
        <div className="mask-container">
      <svg className="mask-svg" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="gradient-bg" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: "#8f00244d", stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: "#feb47b", stopOpacity: 1 }} />
          </linearGradient>
        </defs>

        <path
          id="mask-path"
          d="M0,11.13a9.71,9.71,0,0,0,1,3.1A9.83,9.83,0,0,0,3,16.71C2.59,16-.2,10.83,2.27,5.79A10.6,10.6,0,0,1,5.36,2.08a12.46,12.46,0,0,0-2,7.76,11.71,11.71,0,0,0,.94,3.6C4.15,12.69,3,7.58,6.17,3.7a10.71,10.71,0,0,1,3.89-3A9.93,9.93,0,0,1,14.37,0,10,10,0,0,1,20.75,2.3,7.81,7.81,0,0,1,23.23,6a7.59,7.59,0,0,1-.11,4.52,6.57,6.57,0,0,0-1.18-3.58,6.67,6.67,0,0,0-2.66-2.18,6.9,6.9,0,0,1,2.15,5.67,6.42,6.42,0,0,1-1.67,3.41,5.53,5.53,0,0,0-.84-6.54c.13.24,1.44,2.94.15,5a4.17,4.17,0,0,1-1,1.05,4.67,4.67,0,0,1-3.3.77,3.58,3.58,0,0,0,3.42-3.36,4.33,4.33,0,0,0-.8-3,4.65,4.65,0,0,0-4-2,4.52,4.52,0,0,0-2.26.89,7.43,7.43,0,0,0-2.32,7.86,8.5,8.5,0,0,0,4.48,5,10.13,10.13,0,0,0,7.48.5A10.64,10.64,0,0,0,25,17.47a13,13,0,0,1-5.28,5.84,13.3,13.3,0,0,1-8.79,1.49,13.48,13.48,0,0,1-9-5.91A12.78,12.78,0,0,1,0,11.13Z"
          fill="url(#gradient-bg)"
        />
      </svg>
    </div>
    </main>
   
    </>
  );
};

export default AboutUs;
